module.exports = __webpack_public_path__ + "static/media/Mascot_vic_ddory_jpg.ac428ee6.zip";